import { DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatRadioModule } from '@angular/material/radio';
import { SharedModule } from 'src/app/modules/shared.module';
import { CalloutModule } from '../callout/callout.module';
import { AddonRemoveConfirmationDialogComponent } from './addon-remove-confirmation-dialog.component';
import { AddonsPageComponent } from './addons-page.component';

const components = [
  AddonsPageComponent,
  AddonRemoveConfirmationDialogComponent,
];

@NgModule({
  declarations: [
    ...components,
  ],
  imports: [
    SharedModule,
    CalloutModule,
    MatRadioModule,
  ],
  exports: [
    ...components,
  ],
  providers: [
    DatePipe,
  ],
})
export class AddonsPageModule {}

